import { statelookupjson } from "../../data/schema/shared/StateLookup";

const simpleUtils = {
  cleanQuestionCodeForName: (code) => {
    //eslint-disable-next-line
    return code.replace(/[.\[\]\(\)\<\>]/, "");
  },
  parseMachineNameForObjectBuilding: (obj, uiSchema_nav, uiSchema_lookup) => {
    // obj - flattened case data { field_name: "value" }
    // uiSchema_nav - [{name: "string", symbol|prefix: "string"}]
    // uiSchema_lookup - { field_name: [page_number, field.code, field.label] }
    let ret = [];
    Object.keys(obj).map((machine_name, index) => {
      if (machine_name !== undefined) {
        let lookup = uiSchema_lookup[machine_name];
        if (lookup !== undefined) {
          // refactor this to be object properties instead of array index lookups
          let page = lookup[0];
          let code = lookup[1];
          let label = lookup[2];
          let reviewHidden = lookup[3];
          // column_labels come into play with addendums/tables
          let column_labels = lookup[3];
          let isList = lookup[4] ? true : false;
          let group_label = lookup[5];
          let uiSchemaObj = lookup[lookup.length - 1];
          let isGroup;
          if (uiSchemaObj) {
            isGroup = uiSchemaObj.hasOwnProperty("isGroup");
          }
          let page_title = "";
          let selection;
          if (uiSchema_nav && uiSchema_nav[page]) {
            page_title = uiSchema_nav[page].name;
          }
          let value = obj[machine_name];

          if (code === "II.10" || code === "C3" || code === "D3") {
            // this is for converting state_id into state name
            if (value) {
              let stateObj = statelookupjson.filter((state) => {
                return state.stateId === value;
              });
              if (stateObj && stateObj[0]) {
                value = stateObj[0].state;
              }
            }
          }
          if (
            uiSchemaObj &&
            uiSchemaObj.widget === "checkbox" &&
            typeof value === "number"
          ) {
            if (value) {
              value = uiSchemaObj.choice;
            }
          }
          if (isGroup) {
            switch (uiSchemaObj.isGroup.type) {
              case "radio":
                selection = uiSchemaObj.isGroup.fields.filter(
                  (f) => f.value === value
                );
                if (
                  selection &&
                  selection.length > 0 &&
                  selection[0] &&
                  selection[0].choice
                ) {
                  value = selection[0].choice;
                }
                break;
              default:
            }
          }
          if (value !== null && !isList) {
            // this is for displaying single fields which can exist in a group

            ret.push({
              page_index: page,
              page_title,
              code,
              label,
              column_labels,
              value,
              reviewHidden,
            });
          } else if (value !== null && value && value.length > 0 && isList) {
            // this is for displaying lists/records
            let codeExists = false;
            ret.forEach((o, index) => {
              if (o.hasOwnProperty(code)) {
                ret[index][`${code}`].push({
                  page_index: page,
                  page_title,
                  code,
                  label,
                  column_labels,
                  value,
                });
                codeExists = true;
              }
            });

            if (!codeExists) {
              ret.push({
                page_index: page,
                [`${code}`]: [
                  {
                    page_index: page,
                    page_title,
                    code,
                    label,
                    column_labels,
                    value,
                  },
                ],
                label: group_label,
              });
            }
          }
          return false;
        }
      } else {
        console.error(`There is no machine name for this field: `, obj);
      }
    });
    return ret;
  },
};

export default simpleUtils;
